import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { KycInfo } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number = 'me') =>
    makeCall<KycInfo>('GET', `/api/v2/user/${userId}/kyc-info`);
